module.exports = __webpack_public_path__ + "img/gotodis.13fe2787.png";